import { CircularProgress, Paper } from "@material-ui/core";
import { useFormik } from "formik";
import moment from "moment";
import { useSnackbar } from "notistack";
import TableReportChat from "pages/reports/report-chat/TableReportChat";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { dashboardContact } from "redux/dashboard";
import {
  getRingmeListChatQueueId,
  getRingmeReportChatByDate,
  setRingmeListChatQueueId,
} from "redux/ringme-ott-sdk";
import * as Yup from "yup";

import Dialog from "../../../components/Dialog";
import SearchBar from "./SearchBar";

const validationSchema = Yup.lazy((values) => {
  const maxDate = new Date();
  maxDate.setHours(23, 59, 59, 999);

  let maxEndDate = new Date(values.startDate);
  maxEndDate.setHours(23, 59, 59, 999);
  maxEndDate.setDate(maxEndDate.getDate() + 30);

  if (maxEndDate.getTime() > maxDate.getTime()) {
    maxEndDate = new Date(maxDate);
  }

  const minEndDate = new Date(values.startDate);
  minEndDate.setHours(0, 0, 0, 0);

  return Yup.object().shape({
    startDate: Yup.date().max(maxDate, "Ngày lớn hơn ngày tối đa"),
    endDate: Yup.date()
      .min(minEndDate, "Ngày nhỏ hơn ngày tối thiểu")
      .max(maxEndDate, "Quá 31 ngày hoặc vượt quá ngày tối đa"),
  });
});

const LIST_CHART_CRITERIA = {
  responseRate: {
    id: "responseRate",
    title: "Tỷ lệ trả lời",
  },
  // totalAgent: {
  //   id: "totalAgent",
  //   title: "Số điện thoại viên",
  // },
};

const ReportChat = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const ringmeReportChatByDate = useSelector(
    (state) => state.ringmeOttSdk.ringmeReportChatByDate
  );
  const loadingRingmeReportChatByDate = useSelector(
    (state) => state.ringmeOttSdk.loadingRingmeReportChatByDate
  );
  const listChatQueueId = useSelector(
    (state) => state.ringmeOttSdk.listChatQueueId
  );
  const contacts = useSelector((state) => state.dashboard.contact);

  const [filter, setFilter] = useState(null);

  const [exportExcelRef, setExportExcelRef] = useState();
  const [chartCriteria, setChartCriteria] = useState(
    LIST_CHART_CRITERIA.responseRate.id
  );

  const handleSearch = (searchValues) => {
    setFilter(searchValues);
  };

  const searchForm = useFormik({
    initialValues: {
      reportType: 1,
      startDate: new Date(),
      endDate: new Date(),
      department: "CSKH",
      contactCenter: null,
      // chatChannel: null,
      // pageSource: null,
    },
    validationSchema,
    onSubmit: handleSearch,
  });

  const handleExportFile = async () => {
    if (exportExcelRef) exportExcelRef.save();
  };

  const handleGetChatReport = useCallback(
    (filter) => {
      try {
        if (filter.department !== "CSKH")
          throw new Error("Chưa hỗ trợ bộ phận khác CSKH");

        dispatch(
          getRingmeReportChatByDate({
            chatDepartmentId: filter.contactCenter?.idDepartment,
            from_date: moment(filter.startDate).format("YYYY-MM-DD"),
            to_date: moment(filter.endDate).format("YYYY-MM-DD"),
            type: filter.department,
          })
        );
      } catch (error) {
        console.error(error);
        enqueueSnackbar(error.response?.data?.message || error.message, {
          variant: "error",
        });
      }
    },
    [dispatch, enqueueSnackbar]
  );

  useEffect(() => {
    if (filter) {
      handleGetChatReport(filter);
    }
  }, [filter, handleGetChatReport]);

  useEffect(() => {
    dispatch(dashboardContact());
  }, [dispatch]);

  useEffect(() => {
    if (contacts?.length > 0) {
      dispatch(
        getRingmeListChatQueueId({
          type: "CSKH", // app not support other type
          listChatDepartmentId: contacts.map((item) => item.idDepartment),
        })
      );
    }
    return () => {
      dispatch(setRingmeListChatQueueId([]));
    };
  }, [contacts, dispatch]);

  return (
    <>
      <Paper style={{ color: "black", padding: 16, marginBottom: 16 }}>
        <SearchBar
          searchForm={searchForm}
          onClickExport={handleExportFile}
          listChartCriteria={Object.values(LIST_CHART_CRITERIA)}
          chartCriteria={chartCriteria}
          onChangeChartCriteria={setChartCriteria}
          disabled={listChatQueueId?.length === 0}
        />
      </Paper>

      {!loadingRingmeReportChatByDate && (
        <TableReportChat
          chatReport={ringmeReportChatByDate}
          chartCriteria={chartCriteria}
          onChangeExportRef={setExportExcelRef}
          listChartCriteria={LIST_CHART_CRITERIA}
        />
      )}

      <Dialog
        open={loadingRingmeReportChatByDate}
        title={<CircularProgress />}
      />
    </>
  );
};

export default ReportChat;
